/**
 * Options for loading BVH files
 */
export type BVHLoadingOptions = {
    /**
     * Defines the loop mode of the animation to load.
     */
    loopMode: number;
};
